import { render, staticRenderFns } from "./CandidateDetailsModal.vue?vue&type=template&id=d695c44e&scoped=true&"
import script from "./CandidateDetailsModal.vue?vue&type=script&lang=js&"
export * from "./CandidateDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./CandidateDetailsModal.vue?vue&type=style&index=0&id=d695c44e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d695c44e",
  null
  
)

export default component.exports